var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.06673 1.66406C5.8834 1.66406 4.1084 3.43906 4.1084 5.6224C4.1084 7.76406 5.7834 9.4974 7.96673 9.5724C8.0334 9.56406 8.10006 9.56406 8.15006 9.5724C8.16673 9.5724 8.17506 9.5724 8.19173 9.5724C8.20006 9.5724 8.20006 9.5724 8.2084 9.5724C10.3417 9.4974 12.0167 7.76406 12.0251 5.6224C12.0251 3.43906 10.2501 1.66406 8.06673 1.66406Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 11.7953C9.97495 10.2453 6.18328 10.2453 3.84162 11.7953C2.78328 12.5036 2.19995 13.462 2.19995 14.487C2.19995 15.512 2.78328 16.462 3.83328 17.162C4.99995 17.9453 6.53328 18.337 8.06662 18.337C9.59995 18.337 11.1333 17.9453 12.3 17.162C13.35 16.4536 13.9333 15.5036 13.9333 14.4703C13.925 13.4453 13.35 12.4953 12.3 11.7953Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.225 6.11903C17.3583 7.73569 16.2083 9.15236 14.6166 9.34403C14.6083 9.34403 14.6083 9.34403 14.6 9.34403H14.575C14.525 9.34403 14.475 9.34403 14.4333 9.36069C13.625 9.40236 12.8833 9.14403 12.325 8.66903C13.1833 7.90236 13.675 6.75236 13.575 5.50236C13.5166 4.82736 13.2833 4.2107 12.9333 3.6857C13.25 3.52736 13.6166 3.42736 13.9916 3.39403C15.625 3.25236 17.0833 4.46903 17.225 6.11903Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8918 13.8227C18.8251 14.6311 18.3084 15.3311 17.4418 15.8061C16.6084 16.2644 15.5584 16.4811 14.5168 16.4561C15.1168 15.9144 15.4668 15.2394 15.5334 14.5227C15.6168 13.4894 15.1251 12.4977 14.1418 11.7061C13.5834 11.2644 12.9334 10.9144 12.2251 10.6561C14.0668 10.1227 16.3834 10.4811 17.8084 11.6311C18.5751 12.2477 18.9668 13.0227 18.8918 13.8227Z",
    fill: "#333448",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon08);
export default __webpack_public_path__ + "static/media/menu-icon-08.7aa31712fd175fab2e996e53867f2ef9.svg";
export { ForwardRef as ReactComponent };